import { render, staticRenderFns } from "./Popovers.vue?vue&type=template&id=60931b3c&"
import script from "./Popovers.vue?vue&type=script&lang=js&"
export * from "./Popovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60931b3c')) {
      api.createRecord('60931b3c', component.options)
    } else {
      api.reload('60931b3c', component.options)
    }
    module.hot.accept("./Popovers.vue?vue&type=template&id=60931b3c&", function () {
      api.rerender('60931b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Popovers.vue"
export default component.exports